// ════════════════════════════════════════════════════════
//  features/veiculos/types/index.ts
// ════════════════════════════════════════════════════════

export interface VeiculoListagemDto {
  id:          number;
  placa:       string | null;
  marca:       string | null;
  modelo:      string | null;
  ano:         number;
  anoModelo:   number;
  placaCidade: string | null;
  placaUf:     string | null;
  kmInicial:   number;
  isInativo:   boolean;
  rntrc:       string | null;
  renavam:     string | null;
  pesoBruto:   number;
  pesoLiquido: number;
}

export interface VeiculoComboDto {
  id:     number;
  placa:  string | null;
  modelo: string | null;
}

export interface VeiculoDto {
  id: number;
  // Dados Principais
  placa:                 string | null;
  placaCidade:           string | null;
  placaUf:               string | null;
  renavam:               string | null;
  chassi:                string | null;
  chassiRemarcado:       boolean;
  marca:                 string | null;
  modelo:                string | null;
  ano:                   number;
  anoModelo:             number;
  tipoCombustivel:       number;
  avaliacao:             number;
  temRastreador:         boolean;
  rastreador:            string | null;
  controlaKm:            boolean;
  kmInicial:             number;
  frotaId:               number;
  faixaConsumoId:        number;
  observacao:            string | null;
  isInativo:             boolean;
  dtTrocaFluidoRadiador: string | null;
  dtLimpezaRadiador:     string | null;
  // Inf. Fábrica
  codigoMarcaModelo:  string | null;
  marcaVeiculoId:     number;
  modeloVeiculoId:    number;
  modeloCarroceriaId: number;
  corId:              number;
  lotacao:            string | null;
  eixos:              number;
  distanciaEixo:      number;
  tipoCarga:          string | null;
  potenciaCv:         number;
  cilindradas:        number;
  tipoFreio:          number;
  condicaoVeiculo:    number;
  restricao:          string | null;
  numeroMotor:        string | null;
  motorista:          string | null;
  pesoBruto:          number;
  pesoLiquido:        number;
  rntrc:              string | null;
  // Seguros
  seguradora:          string | null;
  exercicio:           number;
  valorCasco:          number;
  danosMaterialValor:  number;
  danosCorporaisValor: number;
}

export interface SalvarVeiculoRequest {
  // Dados Principais
  placa:                 string;
  placaCidade:           string;
  placaUf:               string;
  renavam:               string;
  chassi:                string;
  chassiRemarcado:       boolean;
  marca:                 string;
  modelo:                string;
  ano:                   number;
  anoModelo:             number;
  tipoCombustivel:       number;
  avaliacao:             number;
  temRastreador:         boolean;
  rastreador:            string;
  controlaKm:            boolean;
  kmInicial:             number;
  frotaId:               number;
  faixaConsumoId:        number;
  observacao:            string;
  isInativo:             boolean;
  dtTrocaFluidoRadiador: string | null;
  dtLimpezaRadiador:     string | null;
  // Inf. Fábrica
  codigoMarcaModelo:  string;
  marcaVeiculoId:     number;
  modeloVeiculoId:    number;
  modeloCarroceriaId: number;
  corId:              number;
  lotacao:            string;
  eixos:              number;
  distanciaEixo:      number;
  tipoCarga:          string;
  potenciaCv:         number;
  cilindradas:        number;
  tipoFreio:          number;
  condicaoVeiculo:    number;
  restricao:          string;
  numeroMotor:        string;
  motorista:          string;
  pesoBruto:          number;
  pesoLiquido:        number;
  rntrc?:             string;
  // Seguros
  seguradora:          string;
  exercicio:           number;
  valorCasco:          number;
  danosMaterialValor:  number;
  danosCorporaisValor: number;
}

export const COMBUSTIVEL_OPTIONS = [
  { value: 1,  label: 'Diesel' },
  { value: 2,  label: 'Gasolina' },
  { value: 3,  label: 'Álcool' },
  { value: 4,  label: 'GNV' },
  { value: 5,  label: 'Flex' },
  { value: 6,  label: 'Elétrico' },
  { value: 7,  label: 'Híbrido' },
];

export const TIPO_FREIO_OPTIONS = [
  { value: 1, label: 'Hidráulico' },
  { value: 2, label: 'Pneumático' },
  { value: 3, label: 'Elétrico' },
  { value: 4, label: 'Mecânico' },
];

export const CONDICAO_VEICULO_OPTIONS = [
  { value: 1, label: 'Novo' },
  { value: 2, label: 'Usado' },
  { value: 3, label: 'Reformado' },
];
